import RequestSummaryModelBase from '../_generated/modelBases/request-summary-model-base';

export default class RequestSummaryModel extends RequestSummaryModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
